// `import.meta.env.DEV` is provided by Vite and is `true` only when the app runs
// via `vite dev`. It is statically replaced with `false` in a production bundle
// (both `vite build` + `vite preview` and when the code is served by the Capacitor
// mobile wrapper). Relying on this flag is more robust than checking
// `process.env.NODE_ENV`, which can be accidentally left undefined or set to an
// unexpected value during the build.
export const isDev = import.meta.env.DEV;
export const isChrome = () => navigator.userAgent.indexOf('Chrome') !== -1;
export const isSafari = () =>
  navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

// Development authentication bypass
export const devRefreshToken = process.env.VITE_DEV_REFRESH_TOKEN;
export const devUserId = process.env.VITE_DEV_USER_ID;
export const isDevWithAuthBypass = isDev && !!devRefreshToken && !!devUserId;

export const APP_ROOT_ID = 'root';

export enum STORAGE_KEYS {
  REFRESH_TOKEN = 'refresh_token',
  CONVERSATION_METHOD = 'conversation_method',
}

export const ERROR_MESSAGES = {
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  WRONG_EMAIL_PASS: 'Wrong email or password.',
  NO_SUBSCRIPTION:
    "It seems like the email you're using to log in doesn't have an active subscription. Please verify the email address or click on the link below to purchase a subscription and continue using our services.",
};

export enum AUTH_CUSTOM_STATUS_CODES {
  UNEXPECTED_ERROR = 1000,
  NOT_AUTHENTICATED = 1001,
  NOT_AUTHORIZED_TIER = 1002,
  EMAIL_ALREADY_EXISTS = 1003,
  INVALID_CREDENTIALS = 1004,
  INVALID_REFRESH_TOKEN = 1005,
  INVALID_EMAIL = 1006,
}

export const BASE_AUTH_ERROR_MESSAGES = {
  [AUTH_CUSTOM_STATUS_CODES.UNEXPECTED_ERROR]:
    'Unexpected error. Please try again later or contact support.',
};

export const isIOS =
  navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);
export const isAndroid = navigator.userAgent.includes('Android');

// Detect Instagram and Facebook in-app browsers
// Instagram UA contains "Instagram", Facebook UA contains "FBAN" or "FBAV"
export const isInAppBrowser = /Instagram|FBAN|FBAV/i.test(navigator.userAgent);

// Combined check for iOS in-app browsers where Google sign-in doesn't work properly
export const isIOSInAppBrowser = Boolean(isIOS && isInAppBrowser);

export const LINKS = {
  FUNNEL: 'https://quiz.leyaai.com/',
  APP_STORE: process.env.VITE_APP_STORE_URL || 'https://apps.apple.com/us/app/leya-ai-english-for-work/id6504925455',
  PLAY_STORE: process.env.VITE_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.leyaai.app',
  FUNNEL_CHECKOUT_PLANS: 'https://quiz.leyaai.com/paywall/paywall-sale',
  TRUST_PILOT_REVIEW:
    'https://www.trustpilot.com/evaluate/leyaai.com?utm_medium=trustbox&utm_source=TrustBoxReviewCollector',
};

export const SEARCH_PARAMS = {
  CONVERSATION_ID: 'conversation_id',
};

export const LEYA_AI_DOMAIN = '.leyaai.com';
